import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { onMounted, reactive, ref, toRefs, watch } from "vue";
import apis from "@/api";
import AssetsCard from "./components/AssetsCard.vue";
import AssetsTable from "./components/AssetsTable.vue";
export default {
  name: 'DialogAssetsLib',
  emits: ['selectedChange', 'close'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '素材库选择'
    },
    operateTitle: {
      type: String,
      default: '印刷品制作'
    }
  },
  components: {
    AssetsCard,
    AssetsTable
  },
  setup(props, ctx) {
    const assetsTableRef = ref({});
    const assetsCardRef = ref({});
    const data = reactive({
      loading: false,
      choseAsset: {},
      form: {
        posName: "",
        tagNum: "",
        tagName: "",
        keys: "",
        offerId: "",
        needUser: "",
        busiLink: "",
        srcTyp: 1,
        subtype: "",
        status: 1,
        pageSize: 20,
        pageNum: 1
      },
      posData: [],
      assetsList: [],
      total: 0,
      activeName: '0',
      assetsSelected: []
    });
    const cascader = {
      label: "nodeName",
      value: "nodeName",
      children: "children",
      emitPath: false,
      checkStrictly: false
    };
    const fetchData = () => {
      data.loading = true;
      apis.assetsSearch(data.form).then(res => {
        if (res.success) {
          data.assetsList = res.data.assets;
          data.total = res.data.total;
          data.assetsList.forEach(val => {
            val.check = false; // 默认未选中
            data.assetsCardSelected = [];
          });
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    onMounted(() => {
      apis.queryPositionTree("").then(res => {
        if (res.success) {
          data.posData = res.data;
        }
      });
    });
    watch(() => data.form.pageNum, fetchData, {
      immediate: true
    });
    const onSubmit = () => {
      fetchData();
    };
    const reset = () => {
      data.form = Object.assign(data.form, {
        posName: "",
        tagNum: "",
        tagName: "",
        keys: "",
        subtype: "",
        offerId: "",
        needUser: "",
        busiLink: "",
        srcTyp: "",
        status: 1
      });
      fetchData();
    };
    const posChange = e => {
      console.log(e);
    };
    const tabsClick = (tab, event) => {
      data.activeName = tab.index;
    };
    const handlerSelectedAssets = () => {
      if (data.activeName === '1') {
        // 卡片模式
        data.assetsSelected = assetsTableRef.value.multipleSelection;
      }
      if (data.assetsSelected.length > 0) {
        ctx.emit("selectedChange", data.assetsSelected);
        ctx.emit("close");
      } else {
        ElMessage.error('请先选择素材文件！');
      }
    };
    const selectChange = item => {
      data.assetsList.forEach(val => {
        if (val.id == item.id) {
          if (val.check) {
            val.check = false;
            data.assetsSelected = _.filter(data.assetsSelected, a => a.id !== item.id);
          } else {
            val.check = true;
            data.assetsSelected.push(item);
          }
        }
      });
    };
    const close = () => {
      data.assetsSelected = [];
      ctx.emit("close", false);
    };
    return {
      ...toRefs(data),
      cascader,
      onSubmit,
      reset,
      posChange,
      fetchData,
      tabsClick,
      handlerSelectedAssets,
      assetsTableRef,
      assetsCardRef,
      selectChange,
      close
    };
  }
};